
var script_loaded = !1; function loadJSscripts() { script_loaded || (void 0 !== uLTS && uLTS.disconnect(), void 0 !== window.yett && window.yett.unblock(), (script_loaded = !0), document .querySelectorAll("iframe[data-src], script[data-src]") .forEach((a) => { null != (datasrc = a.dataset.src) && (a.src = datasrc); }), document.querySelectorAll("link[data-href]").forEach((a) => { null != (datahref = a.dataset.href) && (a.href = datahref); }), document.querySelectorAll("script[type='text/lazyload']").forEach((d) => { var b = document.createElement("script"); for (a = 0; a < d.attributes.length; a++) { var c = d.attributes[a]; b.setAttribute(c.name, c.value); } (b.type = "text/javascript"), (b.innerHTML = d.innerHTML), d.parentNode.insertBefore(b, d), d.parentNode.removeChild(d); }), document.dispatchEvent(new CustomEvent("asyncLazyLoad")), setTimeout(function () { document.dispatchEvent(new CustomEvent("loadBarInjector")); }, 3e3)); } var activityEvents = [ "mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove", ]; activityEvents.forEach(function (a) { window.addEventListener(a, loadJSscripts, !1); }); if (!__isPSA){ loadJSscripts(); } 
jQuery(document).ready(function() {
    console.log( "ready!" );
   
});
// function blink(){
//   let allReviewContentParagraphs = document.querySelectorAll('.kl_reviews__review__content');
//   if (allReviewContentParagraphs.length > 0) {
//     for (i = 0; i < allReviewContentParagraphs.length; i++) {
//       let contentElement = allReviewContentParagraphs[i];
//       if (typeof contentElement != 'undefined' && contentElement) {
//         let nextSibling = contentElement.nextElementSibling;
//         if (typeof nextSibling != 'undefined') {
//           if (nextSibling.getAttribute('class') != "Verifiziert") {
//             console.log(nextSibling.getAttribute('class'));
//             let customElement = '<p style="font-size: 14px" class="Verifiziert"><i class="fa fa-check-circle"></i> Verifiziert, collected by The Garrison B.V.</p>';
//             // customElement.setAttribute('class', 'Verifiziert');
//             // customElement.text = 'Verifiziert';
//             contentElement.insertAdjacentHTML( 'afterend', customElement);
//           }
//         }
//       }
//     }
//   }
//   //  if( jQuery(".kl_reviews__review__content").next().is("p.Verifiziert") ){
//   //   //console.log('next element is ul');
//   // } else {
//   //    jQuery('<p class="Verifiziert">Verifiziert</p>').insertAfter('.kl_reviews__review_item .kl_reviews__review__content');
//   // }
// }
// setInterval(blink,1500);

// jQuery('.kl_reviews__load_more_button .kl_reviews__button').on('click', function(e){
//   e.preventDefault();
// });
jQuery('.variant-input').on('click', function(){
                setTimeout(function() {
                        var url= window.location.href;
                        var ulrsp = url.split('variant=');
                        var urlproductID = ulrsp[1];
                        console.log('url id'+urlproductID);
                        jQuery(".js-variant-inventory-data").each(function(){
                                var proid = jQuery(this).attr("data-id");
                                var proqty = jQuery(this).attr("data-quantity");
                                if(urlproductID==proid && proqty==0){
                                        jQuery('.yp_inventoryProduct .sales-point span:nth-child(2)').text('Nicht auf Lager - 2 Wochen Lieferzeit als?');
                                        jQuery('.yp_inventoryProduct .sales-point span:nth-child(2)').css('color','#000');
                                }
                            });
                }, 1000);
        });

document.addEventListener("DOMContentLoaded", function() {
  // List of words to remove
  const wordsToRemove = ["Peaky Blinders", "peaky blinders", "peaky", "tommy", "thomas", "shelby", "Shelby"];

  // Function to remove words from text content
  function removeWords(element) {
    if (element.hasChildNodes()) {
      element.childNodes.forEach(removeWords);
    } else if (element.nodeType === Node.TEXT_NODE) {
      let text = element.textContent;
      wordsToRemove.forEach(word => {
        const regex = new RegExp(`\\b${word}\\b`, 'gi'); // Case-insensitive match
        text = text.replace(regex, "--");
      });
      element.textContent = text;
    }
  }

  // Apply the function to the whole document
  removeWords(document.body);
});

